import React from 'react';
import styled from 'styled-components';
import { SearchOutlined } from '@ant-design/icons';

const SearchInput = ({ value, onChange, placeholder = "搜索商品..." }) => {
  return (
    <StyledWrapper>
      <SearchOutlined className="search-icon" />
      <input 
        className="input" 
        name="text" 
        placeholder={placeholder} 
        type="search"
        value={value}
        onChange={onChange}
      />
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 300px;

  .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 16px;
  }

  .input {
    width: 100%;
    background-color: #fff;
    color: #242424;
    padding: 8px 12px 8px 36px;
    height: 32px;
    border-radius: 16px;
    outline: none;
    border: 1px solid #d9d9d9;
    line-height: 1.15;
    transition: all 0.3s ease;
    font-size: 14px;

    &::placeholder {
      color: #999;
    }
  }

  input:focus {
    border-color: #D4303B;
    box-shadow: 0 0 0 2px rgba(212, 48, 59, 0.1);
  }

  input:hover {
    border-color: #D4303B;
  }
`;

export default SearchInput; 